import styled from "styled-components";

export const CustomCheckbox = styled.input`
  appearance: none;
  width: 16px;
  height: 16px;
  margin-right: 8px;
  border: 2px solid #666666 ;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  &:checked {
    background-color: #5339e3;
    border-color: #5339e3;
  }

  &:checked::after {
    content: "";
    position: absolute;
    width: 5px;
    height: 10px;
    border: solid white;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    top: 0px;
    left: 4px;
  }
`;
